import React, { useContext, useState } from 'react';
import styled, { css } from 'styled-components';
import { GlobalSettingsContext } from '../../contexts/globalSettings';
import Tab from './Tab';

const TabsStyled = styled.div.attrs({
  className: 'tabs',
})`
  ${props => {
    const { theme = {}, darkMode = false } = props;
    const { colors = {}, fonts = {}, media = {} } = theme;
    return css`
      .tab-list {
        display: inline-block;
        position: relative;

        > div {
          color: #000;
          display: inline-block;

          ${darkMode && `
            color: #fff;
          `}
        }
      }

      .tab-content {
        height: 250px;
        width: 60vw;
        padding: 8px;
        background-color: #fff;
        color: #000;
        border: 1px solid #ccc;
        box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
  
        ${darkMode && `
          background-color: #000;
          color: #fff;
        `}

        &__holder {
          display: block;
          height: 100%;
          overflow: hidden;
          overflow-y: scroll;
          display: none;

          &--active {
            display: block;
          }
        }
      }
    `;
  }}
`;

const Tabs = ({ children }) => {
  const [activeTab, setActiveTab] = useState(Array.isArray(children) ? children[0].props.label : children.props.label);
  const tabItems = Array.isArray(children) ? children : [children];

  const onClickTab = (tab) => {
    setActiveTab(tab);
    setInfo({ lastTab: tab });
  }

  return (
    <TabsStyled darkMode={false} >
      <div className="tab-list">
        {tabItems.map((child) => {
          const { label } = child.props;
          return (
            <Tab
              activeTab={activeTab}
              key={label}
              label={label}
              onClick={onClickTab}
              darkMode={false}
            />
          );
        })}
      </div>
      <div className="tab-content">
        {tabItems.map((child) => {
          // if (child.props.label !== activeTab) return undefined;
          return (
            <div className={`tab-content__holder tab-content__holder--${child.props.label === activeTab ? 'active' : 'hidden'}`}>
              {child.props.children}
            </div>
          );
        })}
      </div>
    </TabsStyled>
  );
  
}

export default Tabs;